<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">Name</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Payment ID" v-model="formData.name">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <h3 style="margin-top:0px;">
                  <span v-if="formData.status == SESSION_CLEARED" class="label label-primary pull-right">{{ formData.status}}</span>
                  <span v-if="formData.status == SESSION_POSTED" class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                     
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_OVERVIEW }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Overview</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_ITEMS }"><a @click="onClickTabItems()" href="#tab_2" data-toggle="tab" aria-expanded="true">Items</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_OVERVIEW }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProject" class="col-sm-4 control-label">Project</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProject" placeholder="" v-model="formData.project_name">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputTotalAmount" class="col-sm-4 control-label">Total Amount</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputTotalAmount" placeholder="" v-model="formData.total_amount" ref="totalAmount">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">   
                            <div class="form-group">
                              <label for="inputBankAccountName" class="col-sm-4 control-label">Bank Account</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputBankAccountName" placeholder="" v-model="formData.bank_account_name">
                              </div>                     
                            </div>                                                                    
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCurrency" class="col-sm-4 control-label">Currency</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputCurrency" placeholder="" v-model="formData.currency_name">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">   
                            <div class="form-group">
                              <label for="inputPaymentChannel" class="col-sm-4 control-label">Payment Channel</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputPaymentChannel" placeholder="" v-model="formData.payment_channel">
                              </div>                     
                            </div>                                                                    
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputMITAccount" class="col-sm-4 control-label">MIT Account</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputMITAccount" placeholder="" v-model="formData.mit_account">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">   
                            <div class="form-group">
                              <label for="inputCompanyName" class="col-sm-4 control-label">Company</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputCompanyName" placeholder="" v-model="formData.company_name">
                              </div>                     
                            </div>                                                                    
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCompanySAPCode" class="col-sm-4 control-label">Company SAP Code</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputCompanySAPCode" placeholder="" v-model="formData.company_sap_code">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">   
                            <div class="form-group">
                              <label for="inputProjectSAPCode" class="col-sm-4 control-label">Project SAP Code</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProjectSAPCode" placeholder="" v-model="formData.project_sap_code">
                              </div>                     
                            </div>                                                                    
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProjectBusinessArea" class="col-sm-4 control-label">Project Business Area</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProjectBusinessArea" placeholder="" v-model="formData.project_business_area">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">   
                            <div class="form-group">
                              <label for="inputProjectProfitCenter" class="col-sm-4 control-label">Project Profit Center</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProjectProfitCenter" placeholder="" v-model="formData.project_profit_center">
                              </div>                     
                            </div>                                                                    
                          </div>
                          <div class="col-md-6">
                            <!-- <div class="form-group">
                              <label for="inputProjectBusinessArea" class="col-sm-4 control-label">Project Business Area</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProjectBusinessArea" placeholder="" v-model="formData.project_business_area">
                              </div>                     
                            </div>                       -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_ITEMS }" class="tab-pane" id="tab_2">
                      <div class="box no-border">
                        <div class="box-header">
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <th style="text-align:center;">Action</th>
                                <th style="text-align:left;">Payment ID</th>
                                <th style="text-align:left;">Payment Type</th>
                                <th style="text-align:right;">Total Amount</th>                    
                                <th style="text-align:left;">Project</th>                    
                                <th style="text-align:left;">First Name</th>
                                <th style="text-align:left;">Last Name</th>
                                <th style="text-align:left;">Email</th>
                                <th style="text-align:center;">Process Date</th>
                                <th style="text-align:center;">Booking Date</th>
                                <th style="text-align:center;">Status</th>   
                                <th style="text-align:left;">Order</th>               
                                <th style="text-align:left;">Transaction ID</th>
                                <th style="text-align:left;">Payment Gateway</th>
                                <th style="text-align:left;">Payment Method</th>
                                <th style="text-align:left;">AcctDoc Deposit</th>
                                <th style="text-align:left;">AcctDoc Incoming</th>
                                <th style="text-align:left;">AcctDoc OtherIncoming</th>
                                <th style="text-align:left;">AcctDoc Deposit-Rev</th>
                                <th style="text-align:left;">AcctDoc Incoming-Rev</th>
                                <th style="text-align:left;">AcctDoc OtherIncoming-Rev</th>                                
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listItem" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceItem + i + 1}}</td>
                                <td style="width:45px;text-align:center;">
                                    <a href="#" v-on:click="onDisplayPayment(row)" ref="displayRow" style="padding-right:5px">
                                    <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Detail Payment"></span>
                                    </a>
                                </td>
                                <td style="text-align:left;" nowrap>{{ row.id }}</td>                     
                                <td style="text-align:left;" nowrap>{{ row.payment_type }}</td>
                                <td style="text-align:right;" nowrap>{{ row.total_amount }}</td>                    
                                <td style="text-align:left;" nowrap>{{ row.project_name }}</td>
                                <td style="text-align:left;" nowrap>{{ row.first_name }}</td>
                                <td style="text-align:left;" nowrap>{{ row.last_name }}</td>
                                <td style="text-align:left;" nowrap>{{ row.email }}</td>
                                <td style="text-align:center;" nowrap>{{ row.process_date }}</td>
                                <td style="text-align:center;" nowrap>{{ row.booking_date }}</td>
                                <td style="text-align:center;">
                                    <span v-if="row.status == STATUS_PENDING" class="badge bg-red">{{ row.status }}</span>
                                    <span v-if="row.status == STATUS_SETTLEMENT" class="badge bg-green">{{ row.status }}</span>
                                </td>                  
                                <td style="text-align:left;" nowrap>{{ row.order_name }}</td>
                                <td style="text-align:left;" nowrap>{{ row.transaction_id }}</td>
                                <td style="text-align:left;" nowrap>{{ row.payment_gateway }}</td>
                                <td style="text-align:left;" nowrap>{{ row.payment_method }}</td>
                                <td style="text-align:left;" nowrap>{{ row.acct_doc_payment }}</td>
                                <td style="text-align:left;" nowrap>{{ row.acct_doc_used_ticket }}</td>
                                <td style="text-align:left;" nowrap>{{ row.acct_doc_expired_ticket }}</td>
                                <td style="text-align:left;" nowrap>{{ row.acct_doc_payment_reversal }}</td>
                                <td style="text-align:left;" nowrap>{{ row.acct_doc_used_ticket_reversal }}</td>
                                <td style="text-align:left;" nowrap>{{ row.acct_doc_expired_ticket_reversal }}</td>
                                <td hidden>{{ row.project_id }}</td>
                                <td hidden>{{ row.company_id }}</td>
                                <td hidden>{{ row.order_id }}</td>
                                <td hidden>{{ row.session_id }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                        </div>                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>                                                                     
              <input type="hidden" class="form-control" v-model="formData.id">
              <input type="hidden" class="form-control" v-model="formData.projectId">
              <input type="hidden" class="form-control" v-model="formData.company_id">
              <input type="hidden" class="form-control" v-model="formData.currency_id">
              <input type="hidden" class="form-control" v-model="formData.order_id">
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_VIEW = 'read'
const STATUS_PENDING = 'pending'
const STATUS_SETTLEMENT = 'settlement'
const SESSION_CLEARED = 'Cleared'
const SESSION_POSTED = 'Posted'
const TAB_OVERVIEW = 'tabOverview'
const TAB_ITEMS = 'tabItems'
const TAB_NOTIFICATION = 'tabNotification'

export default {
  name: 'PaymentClearingSessionForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      STATUS_PENDING: STATUS_PENDING,
      STATUS_SETTLEMENT: STATUS_SETTLEMENT,
      SESSION_CLEARED: SESSION_CLEARED,
      SESSION_POSTED: SESSION_POSTED,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      TAB_OVERVIEW: TAB_OVERVIEW,
      TAB_ITEMS: TAB_ITEMS,
      TAB_NOTIFICATION: TAB_NOTIFICATION,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        total_amount: 0,
        currency_id: 0,
        currency_name: '',
        company_id: 0,
        company_name: '',
        project_id: 0,
        project_name: '',
        status: '',
        bank_account_id: 0,
        bank_account_name: ''
      },
      listItem: null,
      startSequenceItem: 0,
      listNotification: null,
      startSequenceNotification: 0,
      tabActive: '',
      originalcallback: ''
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id ? this.$route.params.id : this.$route.params.callbackId
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.callbackId
    this.originalcallback = this.$route.params.originalcallback
    this.tabActive = TAB_OVERVIEW
    this.getDetail()
  },
  mounted() {
  },
  methods: {
    getDetail() {
      api
        .request('Payment', 'get', '/api/Payment/GetDetailPaymentClearingSession?id=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.formData = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onBack() {
      this.$router.push({ name: 'PaymentClearingList' })
    },
    onClickTabItems() {
      this.inquiryItem()
    },
    inquiryItem() {
      api
        .request('Payment', 'get', '/api/Payment/GetItemsPaymentClearingSession?session_id=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.listItem = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplayPayment(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        clearingStatus: true,
        callback: this.$route.name,
        callbackId: this.formData.id
      }
      this.$router.push({ name: 'Payment', params: params })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PaymentClearingSessionForm.vue?04614d1b